import i18n from "config/i18next"

i18n.addResources('es', 'top', {
    title: 'Aumentá tus ingresos repartiendo paquetes de ',
    eCommerce: 'e-commerce',
    subtitle: 'Una app fácil de usar pensada para que tu experiencia de reparto sea diferente.',
    download: 'Descargala en Play Store',
    downloadMobile: 'Descargala en'
})